/* eslint-disable no-shadow */
import {
  RecurringChecklistItem,
  TaskRecurrenceType,
} from 'Generated/graphql-types'
import { ChecklistItemWithResourceInfo } from 'TypeDefs/Goal'
import moment from 'moment'
import { ISO_8601_DATE_FORMAT } from '../../ImpactReportDashboard/utils'

export enum TimeUnitSubTypeEnum {
  dayOfMonth = 'dayOfMonth',
  dayOfWeek = 'dayOfWeek',
}

export type UpsertTaskHandler = (
  task: Partial<ChecklistItemWithResourceInfo>,
  recurrenceOptions?: RecurringChecklistItem,
  shouldFireCreateEvent?: boolean,
  shouldPopToast?: boolean,
  isRecurring?: boolean
) => Promise<void>

export type DayOfTheMonthValue =
  (typeof dayOfTheMonthSelectOptions)[number]['value']
export type OrdinalWeekValue =
  (typeof weekOfMonthSelectOptions)[number]['value']
export type DayOfTheWeekValue =
  (typeof dayOfTheWeekSelectOptions)[number]['value']

export type RecurrenceOptions = {
  recurrenceType: TaskRecurrenceType
  timeUnitSubType: TimeUnitSubTypeEnum
  frequency: string
  startDate: string | null
  endDate: string | null
  dayOfMonth: DayOfTheMonthValue
  weekOfMonth: OrdinalWeekValue
  dayOfWeek: DayOfTheWeekValue
}

export interface TaskDetailsWithRecurrence
  extends ChecklistItemWithResourceInfo,
    RecurrenceOptions {
  ownerId?: string | null
}

export type UpdateTaskHandlerArgs<K extends keyof TaskDetailsWithRecurrence> = {
  key: K
  value: TaskDetailsWithRecurrence[K]
}

export type OnUpdateOptions = <K extends keyof TaskDetailsWithRecurrence>(
  options: UpdateTaskHandlerArgs<K>
) => void

export const initialTaskDetails = {
  createdAt: new Date().toISOString(),
  linkText: '',
  linkUrl: '',
  title: '',
  updatedAt: '',
}

export const initialRecurrenceOptions = {
  dayOfMonth: '1' as DayOfTheMonthValue,
  dayOfWeek: '1' as DayOfTheWeekValue,
  frequency: '1',
  weekOfMonth: '1' as OrdinalWeekValue,
  startDate: moment().utc().format(ISO_8601_DATE_FORMAT),
  recurrenceType: TaskRecurrenceType.Weekly,
  timeUnitSubType: TimeUnitSubTypeEnum.dayOfMonth,
  endDate: null,
}

export const dayOfTheMonthSelectOptions = [
  { label: '1st', value: '1' },
  { label: '2nd', value: '2' },
  { label: '3rd', value: '3' },
  { label: '4th', value: '4' },
  { label: '5th', value: '5' },
  { label: '6th', value: '6' },
  { label: '7th', value: '7' },
  { label: '8th', value: '8' },
  { label: '9th', value: '9' },
  { label: '10th', value: '10' },
  { label: '11th', value: '11' },
  { label: '12th', value: '12' },
  { label: '13th', value: '13' },
  { label: '14th', value: '14' },
  { label: '15th', value: '15' },
  { label: '16th', value: '16' },
  { label: '17th', value: '17' },
  { label: '18th', value: '18' },
  { label: '19th', value: '19' },
  { label: '20th', value: '20' },
  { label: '21st', value: '21' },
  { label: '22nd', value: '22' },
  { label: '23rd', value: '23' },
  { label: '24th', value: '24' },
  { label: '25th', value: '25' },
  { label: '26th', value: '26' },
  { label: '27th', value: '27' },
  { label: '28th', value: '28' },
  { label: 'Last day of the month', value: 'Last' },
]

export const weekOfMonthSelectOptions = [
  { label: 'First', value: '1' },
  { label: 'Second', value: '2' },
  { label: 'Third', value: '3' },
  { label: 'Fourth', value: '4' },
  { label: 'Last', value: 'Last' },
] as const

export const dayOfTheWeekSelectOptions = [
  { label: 'Sundays', value: '0' },
  { label: 'Mondays', value: '1' },
  { label: 'Tuesdays', value: '2' },
  { label: 'Wednesdays', value: '3' },
  { label: 'Thursdays', value: '4' },
  { label: 'Fridays', value: '5' },
  { label: 'Saturdays', value: '6' },
] as const
